module.exports = __webpack_public_path__ + "img/fanhui_1.b093b6e0.svg";